const testimonials = [
  {
    name: "Brian & Karen H.",
    location: "Pearl River, LA",
    rating: 5,
    text: "We booked a Mardi Gras cruise out of New Orleans and my wife realized her passport had expired. Three weeks before sailing, in a panic. Fast Passport Center had her renewal done in 5 business days. No driving through Causeway traffic to downtown NOLA, no standing in a passport agency line. Just shipped from Slidell and it showed up at our door. We sailed without a problem.",
    service: "Emergency Renewal",
  },
  {
    name: "Jennifer M.",
    location: "Slidell, LA",
    rating: 5,
    text: "I'm an attorney and got invited to an international arbitration conference in London on 10 days' notice. My passport expired during COVID — I barely noticed because I hadn't traveled internationally in years. Fast Passport Center expedited my renewal in 4 business days. I made my flight from MSY and presented my case in London. Professional, fast, and competitively priced.",
    service: "Passport Renewal",
  },
  {
    name: "The Tran Family",
    location: "Lacombe, LA",
    rating: 5,
    text: "We had four passports that needed to be done for a summer Europe trip — my husband, myself, and our two kids. The kids had never had passports before. Fast Passport Center guided us through the whole thing — which offices to visit in St. Tammany Parish for the kids, what forms we needed, and then expedited all four. We got everything in 2 weeks. The Europe trip was incredible.",
    service: "Family Passports — Mixed First-Time & Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SlidellTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Northshore Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Slidell, Pearl River, and Lacombe travelers who trusted Fast Passport Center with their expedited passports — without the Causeway drive.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}